import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import '@/styles/main.scss';

import fontawesome from '@/shared/fontawesome';

createApp(App).use(router).component('fa', fontawesome).mount('#app');
